module.exports = __webpack_public_path__ + "img/space_invaders_record_rear.971591af.jpg";